import React from 'react';
import { CurrencyInput as BaseCurrencyInput } from '@/components/ui/currency-input';
import { CellComponentProps } from '../types';

interface CurrencyInputProps extends CellComponentProps {
  disabled?: boolean;
  invalid?: boolean;
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(({
  value,
  onChange,
  rowIndex,
  column,
  row,
  isExpanded = false,
  disabled = false,
  invalid = false
}, ref) => {
  const currentValue = value as string;

  const handleValueChange = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <BaseCurrencyInput
      ref={ref}
      value={currentValue}
      onValueChange={handleValueChange}
      disabled={disabled}
      invalid={invalid}
      placeholder="$0"
      className="tw-h-[2.5rem]"
    />
  );
});

CurrencyInput.displayName = "CurrencyInput";

export default CurrencyInput;